import CandidateGroupTypes from 'redux/candidate-group/types';

/** ****************************
 * Create candidate group action creators
 ***************************** */

export const createCandidateGroup = (data, cb) => ({
  type: CandidateGroupTypes.CREATE_CANDIDATE_GROUP,
  payload: { data, cb },
});

export const createCandidateGroupSuccess = (candidateGroup) => ({
  type: CandidateGroupTypes.CREATE_CANDIDATE_GROUP_SUCCESS,
  payload: candidateGroup,
});

export const createCandidateGroupFailure = (error) => ({
  type: CandidateGroupTypes.CREATE_CANDIDATE_GROUP_FAILURE,
  payload: error,
});

/** ****************************
 * edit candidate group action creators
 ***************************** */

 export const editCandidateGroup = (id, data, cb) => ({
  type: CandidateGroupTypes.EDIT_CANDIDATE_GROUP,
  payload: { id, data, cb },
});

export const editCandidateGroupSuccess = (candidateGroup) => ({
  type: CandidateGroupTypes.EDIT_CANDIDATE_GROUP_SUCCESS,
  payload: candidateGroup,
});

export const editCandidateGroupFailure = (error) => ({
  type: CandidateGroupTypes.EDIT_CANDIDATE_GROUP_FAILURE,
  payload: error,
});


/** ****************************
 * upadate candidate group headers action creators
 ***************************** */

 export const updateCandidateGroupHeaders = (id, data, cb) => ({
  type: CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS,
  payload: { id, data, cb },
});

export const updateCandidateGroupHeadersSuccess = (candidateGroup) => ({
  type: CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS_SUCCESS,
  payload: candidateGroup,
});

export const updateCandidateGroupHeadersFailure = (error) => ({
  type: CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS_FAILURE,
  payload: error,
});

/** ****************************
 * delete candidate group action creators
 ***************************** */

 export const deleteCandidateGroup = (id, data, cb) => ({
  type: CandidateGroupTypes.DELETE_CANDIDATE_GROUP,
  payload: { id, data, cb },
});

export const deleteCandidateGroupSuccess = (candidateGroup) => ({
  type: CandidateGroupTypes.DELETE_CANDIDATE_GROUP_SUCCESS,
  payload: candidateGroup,
});

export const deleteCandidateGroupFailure = (error) => ({
  type: CandidateGroupTypes.DELETE_CANDIDATE_GROUP_FAILURE,
  payload: error,
});

/** ****************************
 * fetch candidate group action creators
 ***************************** */

 export const fetchCandidateGroup = (data, cb) => ({
  type: CandidateGroupTypes.FETCH_CANDIDATE_GROUP,
  payload: { data, cb },
});

export const fetchCandidateGroupSuccess = (candidateGroup) => ({
  type: CandidateGroupTypes.FETCH_CANDIDATE_GROUP_SUCCESS,
  payload: candidateGroup,
});

export const fetchCandidateGroupFailure = (error) => ({
  type: CandidateGroupTypes.FETCH_CANDIDATE_GROUP_FAILURE,
  payload: error,
});
